// extracted by mini-css-extract-plugin
module.exports = {"buyingProsCard":"buyingPros_buyingProsCard__zSm4u","icon":"buyingPros_icon__ENnXp","proAndIcon":"buyingPros_proAndIcon__suFUA","proText":"buyingPros_proText__11Nk5"};